import {Component, EventEmitter, Input} from '@angular/core';
import {AbstractProdForm, ProdFormField, ProdFormFieldType} from 'prod-form';
import {OrganizationService} from "../../../services/organization.service";
import {Role} from "../../../dip/role";
import {RoleService} from "../../../services/role.service";
import {Organization} from "../../../models/organization";
import {SelectedRecords} from 'prod-grid';
import {OrganizationTreeSelect} from "../../../dip/organization-tree-select";
import {take} from "rxjs";
import {TranslateService} from "@ngx-translate/core";


@Component({
  selector: 'app-distributor-detail',
  templateUrl: './distributor-detail.component.html'
})
export class DistributorDetailComponent extends AbstractProdForm {
  private isFieldsEditable: boolean = this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN]);
  private isSystem: boolean = this.roleService.hasRole([Role.ROLE_SYS]);
  initializeFormEvent$: EventEmitter<void> = new EventEmitter<void>();
  style = {inputWidth: '260px', labelWidth: '120px'};
  records: SelectedRecords = new SelectedRecords();
  fields: ProdFormField[] = [
    ProdFormField.create({
      name: 'name',
      label: this.translate.instant('distributor.details.name'),
      type: ProdFormFieldType.TEXT,
      disabledOnAdd: !this.isSystem,
      isEditable: this.isSystem
    }),
    ProdFormField.create({
      name: 'description',
      label: this.translate.instant('distributor.details.description'),
      type: ProdFormFieldType.TEXTAREA,
      disabledOnAdd: !this.isFieldsEditable,
      isEditable: this.isFieldsEditable
    }),
  ];
  @Input() distributorId: number;
  distributor: Organization;

  constructor(override dataService: OrganizationService,
              private organizationTreeSelect: OrganizationTreeSelect,
              private roleService: RoleService,
              private organizationService: OrganizationService,
              private translate: TranslateService) {
    super();

    this.data.formResponseEvent.subscribe(() => {
      this.ngOnChanges();
    });
  }

  ngOnChanges() {
    this.organizationService.get(this.distributorId).pipe(take(1))
      .subscribe(res => {
        this.distributor = res.data;
        this.records.flush();
        this.records.toggle(this.distributor);
        this.data.records = this.records;
        this.initializeFormEvent$.emit();
        this.isFieldsEditable = this.roleService.hasRole([Role.ROLE_DISTRIBUTOR_ADMIN]);
      })

  }
}
